import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a2339c8")

_pushScopeId("data-v-1a2339c8")
const _hoisted_1 = { class: "role-info" }
const _hoisted_2 = {
  key: 0,
  class: "role-info-wrap"
}
const _hoisted_3 = { class: "role-info-content flex flex-warp justify-start" }
const _hoisted_4 = { class: "content-item-text align-center" }
const _hoisted_5 = { class: "role-info-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("下一步")
const _hoisted_8 = {
  key: 1,
  class: "role-info-wrap"
}
const _hoisted_9 = { class: "section-wrap flex" }
const _hoisted_10 = { class: "section-wrap-avatar flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "section-tag mr32" }, "部门", -1)
const _hoisted_12 = { class: "flex1" }
const _hoisted_13 = { class: "section-wrap-form" }
const _hoisted_14 = { class: "section-form flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "section-input-label" }, "名称：", -1)
const _hoisted_16 = { class: "section-form flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "section-input-label" }, "初始位置：", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "section-input-label" }, "初始状态：", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("隐藏")
const _hoisted_21 = { class: "role-info-footer" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("返回")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sceneDesignMainHeader = _resolveComponent("sceneDesignMainHeader")
  const _component_SceneBox = _resolveComponent("SceneBox")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_departmentalCapacity = _resolveComponent("departmentalCapacity")
  const _component_teamTable = _resolveComponent("teamTable")
  const _component_suppliesTable = _resolveComponent("suppliesTable")
  const _component_SceneEditBox = _resolveComponent("SceneEditBox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.roleInfoModule.showText.value === "home")
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_sceneDesignMainHeader, {
            class: "mb24",
            headerText: _ctx.props.headerText
          }, null, 8, ["headerText"]),
          _createVNode(_component_SceneBox, {
            class: "mb24",
            titleText: "部门",
            loading: _ctx.roleInfoModule.loadings.departmentList
          }, {
            content: _withId(() => [
              _createVNode("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roleInfoModule.roleModule.roleList, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "content-item flex align-items-center direction-column pointer",
                    onClick: ($event: any) => (_ctx.roleInfoModule.showDepartment(item))
                  }, [
                    _createVNode("img", {
                      class: "content-item-img mb8",
                      src: item.roleImg
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_4, _toDisplayString(item.roleName), 1)
                  ], 8, ["onClick"]))
                }), 256))
              ])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              class: "mr18",
              type: "primary",
              onClick: _ctx.roleInfoModule.saveStep
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              class: "next",
              ghost: "",
              onClick: _ctx.roleInfoModule.nextStep
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.roleInfoModule.showText.value === "department")
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_SceneEditBox, {
            class: "mb24",
            loading: _ctx.roleInfoModule.loadings.department,
            editItem: _ctx.roleInfoModule.editDepartmentItem.item,
            isEdit: _ctx.roleInfoModule.isEdit.value,
            onBack: _ctx.roleInfoModule.back,
            onChangeDepartmentStatus: _ctx.roleInfoModule.changeDepartmentStatus
          }, {
            headerContent: _withId(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("img", {
                      class: "section-img border-circle mr16",
                      src: _ctx.roleInfoModule.editDepartmentItem.item.roleImg
                    }, null, 8, ["src"]),
                    _hoisted_11
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_a_input, {
                        class: "w160",
                        value: _ctx.roleInfoModule.editDepartmentForm.item.roleName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roleInfoModule.editDepartmentForm.item.roleName = $event)),
                        maxlength: 10,
                        disabled: _ctx.roleInfoModule.loadings.departmentDisable
                      }, null, 8, ["value", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_a_input, {
                        class: "w240 mr32",
                        value: _ctx.roleInfoModule.editDepartmentForm.item.roleSite,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roleInfoModule.editDepartmentForm.item.roleSite = $event)),
                        maxlength: 10,
                        disabled: _ctx.roleInfoModule.loadings.departmentDisable
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_18,
                      _createVNode(_component_a_select, {
                        value: _ctx.roleInfoModule.formShowStatus.value,
                        onChange: _ctx.roleInfoModule.showStatusChange,
                        disabled: _ctx.roleInfoModule.loadings.departmentDisable,
                        getPopupContainer: (triggerNode) => triggerNode.parentNode
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withId(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withId(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "onChange", "disabled", "getPopupContainer"])
                    ])
                  ])
                ])
              ])
            ]),
            content: _withId(() => [
              _createVNode(_component_SceneBox, {
                class: "mb24",
                titleText: "部门能力"
              }, {
                content: _withId(() => [
                  _createVNode(_component_departmentalCapacity, {
                    capacityList: _ctx.roleInfoModule.editDepartmentForm.item.abliltyList,
                    "onUpdate:capacityList": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roleInfoModule.editDepartmentForm.item.abliltyList = $event)),
                    capacityDefaultList: _ctx.roleInfoModule.capacityDefaultList,
                    loading: _ctx.roleInfoModule.loadings.department,
                    onAddAblilty: _ctx.roleInfoModule.addAblilty,
                    onDelAblilty: _ctx.roleInfoModule.delAblilty,
                    disable: _ctx.roleInfoModule.loadings.departmentDisable
                  }, null, 8, ["capacityList", "capacityDefaultList", "loading", "onAddAblilty", "onDelAblilty", "disable"])
                ]),
                _: 1
              }),
              _createVNode(_component_SceneBox, {
                class: "mb24",
                titleText: "部门资源"
              }, {
                content: _withId(() => [
                  _createVNode(_component_teamTable, {
                    class: "mb50",
                    teamList: _ctx.roleInfoModule.editDepartmentForm.item.teamList,
                    "onUpdate:teamList": _cache[4] || (_cache[4] = ($event: any) => (_ctx.roleInfoModule.editDepartmentForm.item.teamList = $event)),
                    loading: _ctx.roleInfoModule.loadings.department,
                    onAddTeam: _ctx.roleInfoModule.addTeam,
                    onSaveTeam: _ctx.roleInfoModule.saveTeam,
                    onDelTeam: _ctx.roleInfoModule.delTeam,
                    onChangeSaveStatusCheck: _ctx.roleInfoModule.changeSaveStatusCheck,
                    disable: _ctx.roleInfoModule.loadings.departmentDisable
                  }, null, 8, ["teamList", "loading", "onAddTeam", "onSaveTeam", "onDelTeam", "onChangeSaveStatusCheck", "disable"]),
                  _createVNode(_component_suppliesTable, {
                    materialList: _ctx.roleInfoModule.editDepartmentForm.item.materialList,
                    "onUpdate:materialList": _cache[5] || (_cache[5] = ($event: any) => (_ctx.roleInfoModule.editDepartmentForm.item.materialList = $event)),
                    materialDefaultList: _ctx.roleInfoModule.materialDefaultList,
                    loading: _ctx.roleInfoModule.loadings.department,
                    onAddMaterial: _ctx.roleInfoModule.addMaterial,
                    onSaveMaterial: _ctx.roleInfoModule.saveMaterial,
                    onDelMaterial: _ctx.roleInfoModule.delMaterial,
                    onChangeSaveStatusCheck: _ctx.roleInfoModule.changeSaveStatusCheck,
                    disable: _ctx.roleInfoModule.loadings.departmentDisable
                  }, null, 8, ["materialList", "materialDefaultList", "loading", "onAddMaterial", "onSaveMaterial", "onDelMaterial", "onChangeSaveStatusCheck", "disable"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "editItem", "isEdit", "onBack", "onChangeDepartmentStatus"]),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_a_button, {
              class: "mr18",
              type: "primary",
              loading: _ctx.roleInfoModule.loadings.department,
              onClick: _ctx.roleInfoModule.departmentSave
            }, {
              default: _withId(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["loading", "onClick"]),
            _createVNode(_component_a_button, {
              class: "next",
              ghost: "",
              onClick: _ctx.roleInfoModule.back
            }, {
              default: _withId(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})